import { useEffect } from 'react';
import { CSM } from '@atlassian/customer-service-management-widget-sdk-react';
/**
 * Initialises the CSM widget when mounted
 */
export var AiCornerAgent = function AiCornerAgent(_ref) {
  var siteProp = _ref.site,
    siteId = _ref.siteId,
    widgetId = _ref.widgetId;
  useEffect(function () {
    var site = siteProp !== null && siteProp !== void 0 ? siteProp : typeof window !== 'undefined' && window.location.hostname;
    if (!site) {
      return;
    }
    CSM({
      site: site,
      siteId: siteId,
      widgetId: widgetId
    });
  }, [siteProp, siteId, widgetId]);
  return null;
};